import InputField from "@metacrm/metacrm-material-ui/dist/InputField";
import Popup from "@metacrm/metacrm-material-ui/dist/Popup";
import { Box } from "@mui/material";
import axios from "axios";
import { apiUrl } from "features/configure";
import { useFetchUserList } from "features/metadesk/redux/fetchUserList";
import useDispatchSnackbar from "hooks/useDispatchSnackbar";
import { get, omit } from "lodash";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useOutletContext } from "react-router";
import { useIntl } from "react-intl";

export default function ViewModal({ handleViewChange, handleClose }) {
  const { formatMessage } = useIntl();
  const [name, setName] = useState("");
  const [entityName] = useOutletContext();
  const { userListFilter: filter } = useFetchUserList();
  const dispatchSnackbar = useDispatchSnackbar();
  const [error, setError] = useState("");

  async function handleSave() {
    try {
      if (!name?.trim())
        return setError(formatMessage({ id: "global.error.requiredField" }));
      setError("");
      const { data } = await axios.post(
        `${apiUrl}/api/customerReport/${entityName}/view`,
        {
          name,
          filter: omit(filter, "selectedUser"),
        }
      );
      handleViewChange(data);
      dispatchSnackbar({
        message: formatMessage({ id: "global.snackbar.success.saveNewView" }),
        variant: "success",
      });
      handleClose();
    } catch (err) {
      if (get(err, "response.data.error") === "View name already exists") {
        setError(formatMessage({ id: "global.error.nameTaken" }));
      } else {
        dispatchSnackbar({ err });
      }
    }
  }

  return (
    <Popup
      title={formatMessage({ id: "view.popup.title" })}
      open={true}
      onClose={handleClose}
      onConfirm={handleSave}
      onCancel={handleClose}
      sx={{ zIndex: 9999 }}
    >
      <InputField
        title={formatMessage({ id: "global.field.viewName" })}
        isRequired
        placeholder="e.g. Loyal users"
        value={name}
        maxLength={25}
        onChange={(e) => {
          setError("");
          setName(e.target.value);
        }}
        errors={error}
      />
      <Box height="24px" />
    </Popup>
  );
}
